import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Button, Popup, NavBar } from "antd-mobile";
import { Modal } from "antd";
import { Helmet } from "react-helmet";
import Header from "../components/visual/header";
import Footer from "../components/visual/footer";
import PDFViewer from "../components/visual/pdf-viewer-4";
import { FE_BASE_URI } from "../constants/const";

import agenda from "../assets/portada-agenda-1.jpg";
import manual from "../assets/portada-manual-1.jpg";

const LandingPageT = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const closeModal = () => {
        setModalVisible(false);
    };

    return (
        <>
            <Helmet>
                <title>littlecoders.dev. Aprende Python en el Aula - Para Profesores</title>
                <meta name="description" content="Recursos para profesores de tecnología e informática. Agenda escolar con ejercicios de Python semanales para tus alumnos y manual oficial de soluciones." />
                <meta name="keywords" content="agenda para colegios, agenda escolar secundaria, enseñar programación básica, aprender python alumnos, programación profesores tecnología" />
                <meta property="og:title" content="Recursos para Profesores - littlecoders.dev" />
                <meta property="og:description" content="Agenda escolar y manual físico con 40 ejercicios progresivos de Python para tus alumnos de secundaria." />
                <meta property="og:image" content="https://littlecoders.dev/portada-manual-1.jpg" />
            </Helmet>

            <Header />

            {/* Hero Section for Teachers */}
            <div style={{ backgroundColor: "#4F46E5", padding: "80px 20px 60px 20px", color: "white", textAlign: "center" }}>
                <div className="container" style={{ maxWidth: "900px", margin: "0 auto" }}>
                    <h1 style={{ fontSize: "3rem", fontWeight: "900", marginBottom: "20px", lineHeight: "1.2" }}>
                        Conviértete en el profesor/a que inspira pasiones por la <span style={{ color: "#F0F3BD" }}>tecnología</span>.
                    </h1>
                    <p style={{ fontSize: "1.3rem", color: "#E0E7FF", marginBottom: "40px", lineHeight: "1.6" }}>
                        Sabemos que la programación asusta a muchos alumnos. Con la <strong>Agenda Escolar Interactiva</strong> y el <strong>Manual para Profesores</strong> de littlecoders.dev, tendrás recursos físicos estructurados para transformar el miedo en curiosidad de manera sistemática, semana a semana.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
                        <a
                            href="#manual"
                            style={{
                                display: "inline-block",
                                backgroundColor: "#ffffff",
                                color: "#4F46E5",
                                padding: "15px 30px",
                                borderRadius: "30px",
                                fontSize: "1.2rem",
                                fontWeight: "bold",
                                textDecoration: "none",
                                boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
                            }}
                        >
                            Ver Manual del Profesor
                        </a>
                        <Button
                            onClick={() => setModalVisible(true)}
                            className="d-none d-md-block"
                            style={{
                                display: "inline-block",
                                backgroundColor: "transparent",
                                color: "#ffffff",
                                border: "2px solid #ffffff",
                                padding: "10px 30px",
                                borderRadius: "30px",
                                fontSize: "1.2rem",
                                fontWeight: "bold",
                                textDecoration: "none",
                                height: "auto"
                            }}
                        >
                            <i className="fa-solid fa-magnifying-glass me-2"></i>
                            Previsualizar Agenda
                        </Button>
                    </div>
                </div>
            </div>

            {/* Ventajas para los alumnos */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "80px 20px" }}>
                <div className="container" style={{ maxWidth: "1000px", margin: "0 auto" }}>
                    <h2 style={{ textAlign: "center", fontSize: "2.2rem", color: "#333", marginBottom: "50px", fontWeight: "bold" }}>
                        ¿Qué ventajas aporta la agenda a tus alumnos?
                    </h2>

                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "40px" }}>
                        <div style={{ flex: "1 1 400px" }}>
                            <img
                                src={agenda}
                                alt="Agenda Escolar Python"
                                style={{ width: "100%", borderRadius: "15px", boxShadow: "0 20px 40px rgba(0,0,0,0.15)", transform: "rotate(-5deg)" }}
                            />
                        </div>
                        <div style={{ flex: "1 1 400px" }}>
                            <ul style={{ listStyle: "none", padding: 0 }}>
                                <li style={{ marginBottom: "25px" }}>
                                    <h4 style={{ color: "#4F46E5", fontWeight: "bold", fontSize: "1.3rem" }}><i className="fa-solid fa-clock me-2"></i>Ahorras tiempo explicando lo básico</h4>
                                    <p style={{ color: "#666", fontSize: "1.1rem" }}>Cada semana tienen nuevos ejercicios de Python guiados para que aprendan conceptos desde 0 hasta avanzados directamente en papel.</p>
                                </li>
                                <li style={{ marginBottom: "25px" }}>
                                    <h4 style={{ color: "#4F46E5", fontWeight: "bold", fontSize: "1.3rem" }}><i className="fa-solid fa-qrcode me-2"></i>Código QR Dinámico</h4>
                                    <p style={{ color: "#666", fontSize: "1.1rem" }}>Pueden escanear los retos e ir directos a practicar en el <strong>Playground</strong> oficial sin instalar nada en los PCs del centro.</p>
                                </li>
                                <li style={{ marginBottom: "25px" }}>
                                    <h4 style={{ color: "#4F46E5", fontWeight: "bold", fontSize: "1.3rem" }}><i className="fa-solid fa-code me-2"></i>Interacción vs Miedo</h4>
                                    <p style={{ color: "#666", fontSize: "1.1rem" }}>La interfaz del interior replica a <strong>Visual Studio Code</strong>. Entienden la sintaxis y los colores antes siquiera de abrir un editor real.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Recursos Disponibles (El Manual) */}
            <div id="manual" style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
                <div className="container" style={{ maxWidth: "1000px", margin: "0 auto" }}>
                    <h2 style={{ textAlign: "center", fontSize: "2.2rem", color: "#4F46E5", marginBottom: "50px", fontWeight: "bold" }}>
                        Recursos disponibles para ti
                    </h2>

                    <div style={{ backgroundColor: "#f3f4f6", borderRadius: "20px", padding: "40px", display: "flex", flexWrap: "wrap", alignItems: "center", gap: "40px", boxShadow: "0 10px 30px rgba(0,0,0,0.05)" }}>
                        <div style={{ flex: "1 1 300px", textAlign: "center" }}>
                            <img
                                src={manual}
                                alt="Manual con ejercicios de Python para Profesores"
                                style={{ width: "90%", maxWidth: "350px", borderRadius: "10px", boxShadow: "0 15px 30px rgba(0,0,0,0.2)" }}
                            />
                        </div>
                        <div style={{ flex: "1 1 400px" }}>
                            <h3 style={{ fontSize: "1.8rem", color: "#333", fontWeight: "bold", marginBottom: "20px" }}>
                                El Manual de Ejercicios
                            </h3>
                            <p style={{ fontSize: "1.1rem", color: "#555", lineHeight: "1.6", marginBottom: "20px" }}>
                                ¿Prefieres usar la agenda solo como guía didáctica? Este manual recoge exclusivamente los **40 ejercicios de programación progresiva** sin los calendarios ni horarios organizativos, diseñado pensando plenamente en docentes que quieren integrarlo como libro de prácticas en clase.
                            </p>

                            <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", marginTop: "30px" }}>
                                <a
                                    href="https://api3.destinodocente.es/portal/redirect?url=https://www.amazon.es/dp/B0F65G26JD&utm_source=home-lc-1-3"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        backgroundColor: "#4F46E5",
                                        color: "white",
                                        padding: "12px 25px",
                                        borderRadius: "25px",
                                        fontWeight: "bold",
                                        textDecoration: "none"
                                    }}
                                >
                                    <i className="fa-solid fa-book me-2"></i>Versión en Papel
                                </a>
                                <a
                                    href="https://api3.destinodocente.es/portal/redirect?url=https://www.amazon.es/dp/B0F5MXCF1H&utm_source=home-lc-1-4"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        backgroundColor: "#333",
                                        color: "white",
                                        padding: "12px 25px",
                                        borderRadius: "25px",
                                        fontWeight: "bold",
                                        textDecoration: "none"
                                    }}
                                >
                                    <i className="fa-brands fa-amazon me-2"></i>Versión Kindle
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Sección del Playground */}
            <div style={{ backgroundColor: "#4F46E5", padding: "60px 20px", color: "white", textAlign: "center" }}>
                <h2 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "20px" }}>
                    Un Playground siempre disponible
                </h2>
                <p style={{ fontSize: "1.2rem", maxWidth: "600px", margin: "0 auto 30px auto", color: "#E0E7FF" }}>
                    Nuestra web cuenta con la tercera pieza del puzzle: el Playground. Un editor de Python en la nube donde probarán su código al instante desde casa o colegio.
                </p>
                <Link
                    to="/playground"
                    style={{
                        display: "inline-block",
                        backgroundColor: "#FA824C",
                        color: "white",
                        padding: "15px 30px",
                        borderRadius: "30px",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        textDecoration: "none"
                    }}
                >
                    <i className="fa-solid fa-code me-2"></i>Ir al Playground de pruebas
                </Link>
            </div>

            <Footer />

            <Modal open={modalVisible} onCancel={closeModal} footer={null}
                style={{ top: 0, padding: 0, height: '99vh', maxWidth: '100vw' }}
                bodyStyle={{ height: 'calc(100vh - 50px)', overflowY: 'auto' }}>
                <div>
                    <PDFViewer url={FE_BASE_URI + "preview2425.pdf"} />
                </div>
            </Modal>

            <Popup
                visible={isDrawerOpen}
                getContainer={false}
                onMaskClick={() => setIsDrawerOpen(false)}
                bodyStyle={{ width: "100%" }}
                position="left"
            >
                <NavBar onBack={() => setIsDrawerOpen(false)} className="back-bar">
                    Previsualizar Agenda
                </NavBar>
                <div className="pt-1">
                    <PDFViewer url={FE_BASE_URI + "preview2425.pdf"} />
                </div>
            </Popup>
        </>
    );
};

export default LandingPageT;
